import { createContext, useContext } from 'react';

export const WalletFrontPageStickyOffsetContext = createContext(0);

export const useWalletFrontPageStickyOffset = () => useContext(WalletFrontPageStickyOffsetContext);
